import { useState, useEffect } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../../context/AdminAuthContext';

const cyan = '#00e5ff';

const NAV = [
  { label: 'Dashboard',        path: '/admin/dashboard',           icon: '⊞' },
  { label: 'Users',            path: '/admin/users',               icon: '◎' },
  { label: 'Slots / Plans',    path: '/admin/plans',               icon: '◆' },
  { label: 'Slot Upgrades',    path: '/admin/user-slot-upgrades',  icon: '📈' },
  { label: 'Deposit Intent',   path: '/admin/payments',            icon: '⇓' },
  { label: 'Profile Requests', path: '/admin/profile-req',         icon: '👤' },
  { label: 'Support Tickets',  path: '/admin/support-tickets',     icon: '🎫' },
  { label: 'Withdrawals',      path: '/admin/withdrawals',         icon: '⇅' },
  { label: 'Fees History',     path: '/admin/fees',                icon: '💰' },
  { label: 'Commission Paid',  path: '/admin/commission-payouts',  icon: '💳' },
  { label: 'Transactions',     path: '/admin/transactions',        icon: '◈' },
  { label: 'Commission Jobs',  path: '/admin/commissions',         icon: '⚙' },
];

const AdminLayout = () => {
  const { adminUser, logoutAdmin } = useAdminAuth();
  const navigate = useNavigate();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleLogout = () => { logoutAdmin(); navigate('/admin'); };

  const NavMenu = () => (
    <nav style={{ flex: 1, padding: '12px 0' }}>
      {NAV.map(({ label, path, icon }) => (
        <NavLink
          key={path}
          to={path}
          onClick={() => isMobile && setDrawerOpen(false)}
          style={({ isActive }) => ({
            display: 'flex', alignItems: 'center', gap: 10,
            padding: '10px 20px', fontSize: 13, fontWeight: 500,
            color: isActive ? cyan : '#888',
            background: isActive ? 'rgba(0,229,255,0.07)' : 'transparent',
            borderLeft: isActive ? `2px solid ${cyan}` : '2px solid transparent',
            textDecoration: 'none',
            transition: 'all 0.15s',
          })}
        >
          <span style={{ fontSize: 14 }}>{icon}</span>
          {label}
        </NavLink>
      ))}
    </nav>
  );

  const SidebarContent = () => (
    <>
      {/* Logo */}
      <div style={{ padding: '24px 20px 16px', borderBottom: '1px solid rgba(0,229,255,0.08)' }}>
        <div style={{ fontSize: 18, fontWeight: 800, color: '#fff' }}>
          One<span style={{ color: cyan }}>Circle</span>
        </div>
        <div style={{ color: '#444', fontSize: 11, marginTop: 2 }}>Admin Panel</div>
      </div>

      <NavMenu />

      {/* Footer */}
      <div style={{ padding: '16px 20px', borderTop: '1px solid rgba(0,229,255,0.08)' }}>
        <div style={{ color: '#555', fontSize: 11, marginBottom: 8 }}>{adminUser?.name || 'Admin'}</div>
        <button
          onClick={handleLogout}
          style={{ background: 'none', border: '1px solid rgba(255,255,255,0.1)', color: '#666', borderRadius: 6, padding: '5px 14px', fontSize: 12, cursor: 'pointer', width: '100%' }}
        >
          Logout
        </button>
      </div>
    </>
  );

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#0a0a0a' }}>
      {/* Desktop Sidebar */}
      {!isMobile && (
        <aside style={{ width: 230, background: '#0d0d0d', borderRight: '1px solid rgba(0,229,255,0.1)', display: 'flex', flexDirection: 'column', flexShrink: 0 }}>
          <SidebarContent />
        </aside>
      )}

      {/* Mobile Drawer */}
      {isMobile && drawerOpen && (
        <>
          <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', zIndex: 999 }} onClick={() => setDrawerOpen(false)} />
          <aside style={{ position: 'fixed', left: 0, top: 0, width: 230, height: '100vh', background: '#0d0d0d', borderRight: '1px solid rgba(0,229,255,0.1)', display: 'flex', flexDirection: 'column', zIndex: 1000, overflowY: 'auto' }}>
            <SidebarContent />
          </aside>
        </>
      )}

      {/* Main Content */}
      <main style={{ flex: 1, display: 'flex', flexDirection: 'column', overflowY: 'auto' }}>
        {/* Mobile Header */}
        {isMobile && (
          <div style={{ background: '#0d0d0d', borderBottom: '1px solid rgba(0,229,255,0.1)', padding: '12px 16px', display: 'flex', alignItems: 'center', gap: 12, flexShrink: 0 }}>
            <button
              onClick={() => setDrawerOpen(true)}
              style={{ background: 'none', border: 'none', color: cyan, fontSize: 20, cursor: 'pointer', padding: 0 }}
            >
              ☰
            </button>
            <div style={{ fontSize: 14, fontWeight: 700, color: '#fff' }}>One<span style={{ color: cyan }}>Circle</span></div>
          </div>
        )}

        <div style={{ flex: 1, padding: isMobile ? '20px 16px' : '28px 32px', overflowY: 'auto' }}>
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;
